import { wslAxios } from "../config/axiosConfig";

export const fetchLibrariesList = async () => {
  try {
    const response = await wslAxios.get("/user/libraries/list", {
      headers: {
        "app-api-key": process.env.REACT_APP_API_KEY || "",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching libraries list:", error);
    throw error;
  }
};

export interface SipLoginPayload {
  libraryId: string;
  libraryCardId: string;
  pin: string;
}

export const sipLogin = async (
  payload: SipLoginPayload
): Promise<{ success: boolean; data?: any; message?: string }> => {
  try {
    const res = await wslAxios.post("/user/auth/sip-login", payload, {
      headers: {
        "app-api-key": process.env.REACT_APP_API_KEY || "",
        "Content-Type": "application/json",
      },
    });
    return { success: true, data: res.data };
  } catch (err: any) {
    console.error("SIP login error:", err);

    const message =
      err?.response?.data?.data || "Something went wrong. Please try again.";

    return { success: false, message };
  }
};

export interface PatronLoginPayload {
  libraryId: string;
  libraryCardId: string;
  pin: string;
}

export const patronLogin = async (
  payload: PatronLoginPayload
): Promise<{ success: boolean; data?: any; message?: string }> => {
  try {
    const res = await wslAxios.post("/user/auth/patron-login", payload, {
      headers: {
        "app-api-key": process.env.REACT_APP_API_KEY || "",
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (err: any) {
    console.error("Patron login error:", err);

    const message =
      err?.response?.data?.data || "Something went wrong. Please try again.";

    return { success: false, message };
  }
};

export const userLogout = async (): Promise<{
  success: boolean;
  data?: any;
  message?: string;
}> => {
  try {
    const token = localStorage.getItem("token");

    if (!token) {
      throw new Error("No token found in localStorage");
    }

    const res = await wslAxios.post(
      "/user/auth/logout",
      {},
      {
        headers: {
          "app-api-key": process.env.REACT_APP_API_KEY || "",
        },
      }
    );

    return res.data;
  } catch (err) {
    console.error("User logout error:", err);
    throw err;
  }
};
